// extracted by mini-css-extract-plugin
export default {"bx":"dashboardordertype_bx__3x+sp","table":"dashboardordertype_table__PGfuG","tr":"dashboardordertype_tr__rv+uL"};